<div class='video-container'>
  <div *ngIf='videoCameraSources.length === 0 && !warningMessage' class='preview-spinner'></div>
  <div *ngIf="warningMessage" class='empty-video-warning'>{{warningMessage}}</div>

  <div class='main-video'>
    <img [attr.src]="selectedVideoCameraSource?.SourceUrl"
         name='mainVideo'
         (error)="updateErrorSourceUrl($event)"/>
  </div>

  <div class='preview-video-container' *ngIf='videoCameraSources.length > 0'>
    <img class='preview-video'
         [ngClass]='source.Selected ? "preview-video-selected" : ""'
         (error)="updateErrorSourceUrl($event)"
         (click)='selectCamera(source)'
         *ngFor='let source of videoCameraSources; let i = index' [attr.src]="source?.SourceUrl"
         [name]={i}
    />
  </div>
</div>

